"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Highlighted = void 0;
const react_1 = __importDefault(require("react"));
const match_1 = __importDefault(require("autosuggest-highlight/match"));
const parse_1 = __importDefault(require("autosuggest-highlight/parse"));
const segment_1 = require("../segment");
const Highlighted = ({ text, query }) => {
    const matches = (0, match_1.default)(text, query, {
        insideWords: true,
        findAllOccurrences: true,
        requireMatchAll: true,
    });
    const parts = (0, parse_1.default)(text, matches);
    return (react_1.default.createElement(react_1.default.Fragment, null, parts.map((part, index) => react_1.default.createElement(segment_1.Segment, { highlight: !!part.highlight, key: `${part.text}-${index}` }, part.text))));
};
exports.Highlighted = Highlighted;
exports.default = exports.Highlighted;
